import {
  BASICARRAYINPUT_DEFAULT_VALUE,
  AFFILIATIONS_DEFAULT_VALUE,
  PERSON_DEFAULT_VALUE,
  BASIC_INPUT_DEFAULT_VALUE,
  REFERENCES_DEFAULT_VALUE,
  DATE_INPUT_DEFAULT_VALUE,
} from '../../constants/editJournalDefaultValues';

export default {
  templateType: null,
  title: BASIC_INPUT_DEFAULT_VALUE,
  subtitle: BASIC_INPUT_DEFAULT_VALUE,
  sponsor: BASIC_INPUT_DEFAULT_VALUE,
  subject: BASIC_INPUT_DEFAULT_VALUE,
  email: BASIC_INPUT_DEFAULT_VALUE,
  publishedDate: DATE_INPUT_DEFAULT_VALUE,
  authors: PERSON_DEFAULT_VALUE,
  professors: PERSON_DEFAULT_VALUE,
  affiliations: AFFILIATIONS_DEFAULT_VALUE,
  keywords: BASICARRAYINPUT_DEFAULT_VALUE,
  notes: BASICARRAYINPUT_DEFAULT_VALUE,
  references: REFERENCES_DEFAULT_VALUE,
  paragraphComponents: null,
  parents: null,
  correspondingAuthor: 0,
  addReferenceFocusPoint: 0,
  isDocumentEdited: false,
  error: false,
  history: null,
  counter: {},
};
